module.exports = __webpack_public_path__ + "img/highmast_voltage_fault.daee499a.svg";